module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('div', {
    staticClass: "page-content"
  }, [_c('page-nav-bar', {
    attrs: {
      "currentServiceName": "MoneyRoad",
      "subNavTitle": "Import Direct Payments Report",
      "popoverName": ".popoverReportDP"
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "row marginTopList"
  }), _vm._v(" "), _c('div', {
    staticClass: "layoutSubtitle"
  }), _vm._v(" "), _c('f7-list', {
    staticClass: "searchbar-not-found"
  }, [_c('f7-list-item', {
    attrs: {
      "title": "Nothing found"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "webdatalist"
  }, [_c('f7-list', {
    staticClass: "searchbar-found polsize",
    attrs: {
      "id": "bank-list",
      "media-list": ""
    }
  }, [_c('f7-list-item', [_c('b-row', [_c('b-col', {
    attrs: {
      "cols": "2",
      "offset-md": "1"
    }
  }, [_c('h2', [_c('b-badge', {
    staticStyle: {
      "background-color": "#EFEFEF",
      "color": "black"
    },
    attrs: {
      "variant": "light"
    }
  }, [_vm._v("All " + _vm._s(_vm.countAll))])], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h2', [_c('b-badge', {
    staticStyle: {
      "background-color": "#EFEFEF",
      "color": "black"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "check",
      "color": "green"
    }
  }), _vm._v(" " + _vm._s(_vm.countSuccess))], 1)], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h2', [_c('b-badge', {
    staticStyle: {
      "background-color": "#EFEFEF",
      "color": "black"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "exclamation-triangle",
      "color": "yellow"
    }
  }), _vm._v(" " + _vm._s(_vm.countWarning))], 1)], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h2', [_c('b-badge', {
    staticStyle: {
      "background-color": "#EFEFEF",
      "color": "black"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "close",
      "color": "red"
    }
  }), _vm._v(" " + _vm._s(_vm.countError))], 1)], 1)]), _vm._v(" "), _c('b-col', {
    attrs: {
      "cols": "2"
    }
  }, [_c('h2', [_c('b-badge', {
    staticStyle: {
      "background-color": "#EFEFEF",
      "color": "black"
    },
    attrs: {
      "variant": "light"
    }
  }, [_c('f7-icon', {
    attrs: {
      "fa": "refresh",
      "color": "black"
    }
  }), _vm._v(" " + _vm._s(_vm.countOther))], 1)], 1)])], 1)], 1), _vm._v(" "), _vm._l((_vm.report), function(entry, index) {
    return _c('f7-list-item', {
      key: 'rep-' + index,
      attrs: {
        "title": entry.reason,
        "subtitle": entry.creditorName
      }
    }, [_c('span', {
      attrs: {
        "slot": "after"
      },
      slot: "after"
    }, [_vm._v(_vm._s(entry.amount) + " " + _vm._s(entry.currency))]), _vm._v(" "), _c('f7-icon', {
      attrs: {
        "slot": "media",
        "fa": _vm.getIcon(entry.done),
        "color": _vm.getColor(entry.done)
      },
      slot: "media"
    })], 1)
  })], 2)], 1)], 1)])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-acfa7b94", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-acfa7b94","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/services/directPayments/sendbox/ImportReportDP.vue
// module id = 2431
// module chunks = 2